












































































































import Vue, { PropType } from "vue";

import RestClient, { RestError } from "../../RestClient";
import DateFormatter from "../../shared/DateFormatter";
import Loading from "../general/Loading.vue";
import EventsBookingDetails from "../events/EventsBookingDetails.vue";

import SettingsJson from "../../shared/SettingsJson";
import ContactJson from "../../shared/ContactJson";
import EventJson from "../../shared/EventJson";
import { EventStatus } from "../../shared/EventStatus";
import EventBookingJson from "../../shared/EventBookingJson";
import { EventWithBookingsJson } from "../../shared/EventJson";
import { EventWithBookingJson } from "../../shared/EventJson";
import { EventBookingStatus, EventBookingStatusNames } from "../../shared/EventBookingStatus";

import { UserPermissionRank } from "../../shared/UserPermissionRank";
import TableView, { TableViewColumnDefinitions } from "../controls/TableView.vue";

export default Vue.extend({
  name: "EventsOverview",
  components: {
    Loading,
    TableView,
    EventsBookingDetails,
  },
  props: {
    restClient: RestClient,
    loginId: Number,
    loginPermission: Number,
    settings: Object as PropType<SettingsJson>,
    appFrameClickedButton: Object,
  },
  data() {
    return {
      DateFormatter: DateFormatter,
      UserPermissionRank: UserPermissionRank,
      EventBookingStatusNames: EventBookingStatusNames,
      showDetails: false,
      detailsMode: "read",
      attentionalEventBookings: null as EventWithBookingJson[] | null,
      attentionalEventBookingsMoreAvailable: null as boolean | null,
      attentionalEvents: null as EventJson[] | null,
      attentionalEventsMoreAvailable: null as boolean | null,
      attentionalEventBookingsIndividual: null as EventJson[] | null,
      attentionalEventBookingsIndividualMoreAvailable: null as boolean | null,
      selectedEventId: null as number | null,

      selectedEventBookingId: null as number | null,
      isExporting: false,
    };
  },
  created() {
    this.$emit("showAppFrameButtons", { reload: true });
    this.loadData();
  },
  methods: {
    toggleDetails: function () {
      this.showDetails = !this.showDetails;
      if (this.showDetails == false) {
        this.reloadData();
      }
    },

    openDetails(item: EventWithBookingJson | null, mode: string) {
      if (item != null) {
        this.selectedEventId = item.ID;
        this.selectedEventBookingId = item.booking.ID;

        this.detailsMode = mode;
        this.toggleDetails();
      }
    },

    loadData() {
      this.loadAttentionalEventBookings();
      this.loadAttentionalEvents();
      this.loadAttentionalEventBookingsIndivudial();
    },

    async loadAttentionalEventBookings(loadMore: null = null) {
      var states = [EventBookingStatus.requested];
      var bookedAfterDateTime = null;

      //load more
      if (loadMore && this.attentionalEventBookings != null) {
        this.attentionalEventBookingsMoreAvailable = null;

        let lastBooking = this.attentionalEventBookings[this.attentionalEventBookings.length - 1].booking;

        bookedAfterDateTime = new Date(lastBooking.bookingDateTime);
      } else {
        this.attentionalEventBookings = null;
      }

      //final load events
      if (this.restClient != null) {
        try {
          let bookings = await this.restClient.getAggregatedEventBookings(states, bookedAfterDateTime);

          if (loadMore && this.attentionalEventBookings != null) {
            this.attentionalEventBookings = this.attentionalEventBookings.concat(bookings.eventBookings);
          } else {
            this.attentionalEventBookings = bookings.eventBookings;
          }

          this.attentionalEventBookingsMoreAvailable = bookings.moreAvailable;
        } catch (e) {
          alert(e.message);
        }
      }
    },

    async loadAttentionalEvents(loadMore: null = null) {
      var states = [EventStatus.displayed];
      var afterDateTime = new Date();
      afterDateTime.setHours(0, 0, 0);
      var beforeDateTime = new Date();
      beforeDateTime.setHours(0, 0, 0);
      beforeDateTime.setDate(afterDateTime.getDate() + 1);
      var skipAmount = null as number | null;

      //load more
      if (loadMore && this.attentionalEvents != null) {
        this.attentionalEventsMoreAvailable = null;
        skipAmount = this.attentionalEvents.length;
      } else {
        this.attentionalEvents = null;
      }

      console.log(afterDateTime + " " + beforeDateTime);

      //final load events
      if (this.restClient != null) {
        try {
          let events = await this.restClient.getEvents(
            states,
            false,
            false,
            false,
            null,
            afterDateTime,
            beforeDateTime,
            null,
            false,
            skipAmount
          );

          if (loadMore && this.attentionalEvents != null) {
            this.attentionalEvents = this.attentionalEvents.concat(events.events);
          } else {
            this.attentionalEvents = events.events;
          }

          this.attentionalEventsMoreAvailable = events.moreAvailable;
        } catch (e) {
          alert(e.message);
        }
      }
    },

    async loadAttentionalEventBookingsIndivudial(loadMore: null = null) {
      var states = [
        EventBookingStatus.requested,
        EventBookingStatus.bookedReadyForDepositPayment,
        EventBookingStatus.bookedDepositPaymentExported,
        EventBookingStatus.readyForPayment,
        EventBookingStatus.paymentExported,
        EventBookingStatus.paymentReceived,
      ];
      var afterDateTime = new Date();
      afterDateTime.setHours(0, 0, 0);
      var beforeDateTime = new Date();
      beforeDateTime.setHours(0, 0, 0);
      beforeDateTime.setDate(afterDateTime.getDate() + 1);
      var skipAmount = null as number | null;

      //load more
      if (loadMore && this.attentionalEventBookingsIndividual != null) {
        this.attentionalEventBookingsIndividualMoreAvailable = null;
        skipAmount = this.attentionalEventBookingsIndividual.length;
      } else {
        this.attentionalEventBookingsIndividual = null;
      }

      //final load events
      if (this.restClient != null) {
        try {
          let bookings = await this.restClient.getAggregatedEventBookings(states, null, afterDateTime, beforeDateTime);

          if (loadMore && this.attentionalEventBookingsIndividual != null) {
            this.attentionalEventBookingsIndividual = this.attentionalEventBookingsIndividual.concat(
              bookings.eventBookings
            );
          } else {
            this.attentionalEventBookingsIndividual = bookings.eventBookings;
          }

          this.attentionalEventBookingsIndividualMoreAvailable = bookings.moreAvailable;
        } catch (e) {
          alert(e.message);
        }
      }
    },

    async reloadData() {
      this.loadData();
    },

    getAllParticipantNames(participants: ContactJson[]) {
      var names = "";

      for (let i = 0; i < participants.length; i++) {
        if (i != 0) {
          names += ", ";
        }
        names += participants[i].firstName;
        names += " ";
        names += participants[i].lastName;
      }

      return names;
    },

    //tableView
    tableViewButtonClicked(button: string, item: any) {
      if (button == "openDetailsEdit") {
        this.openDetails(item, "edit");
      } else if (button == "showParticipants") {
        this.$emit("changeMainTabbarTab", "EventsParticipants", item.ID);
      }
    },

    tableViewItemClicked(item: any) {
      this.openDetails(item, "read");
    },

    tableViewItemClickedEvent(item: any) {
      this.$emit("changeMainTabbarTab", "EventsParticipants", item.ID);
    },
  },
  watch: {
    appFrameClickedButton: function () {
      if (this.appFrameClickedButton.reload) {
        this.loadData();
      }
    },
  },
  computed: {
    permissionAbleManagement: function () {
      if (this.loginPermission >= this.UserPermissionRank.management) {
        return true;
      } else {
        return false;
      }
    },

    eventBookingColumns: function (): TableViewColumnDefinitions<EventWithBookingJson>[] {
      let vue = this;

      return [
        {
          th: "Veranstaltung",
          td: (i) => i.title,
        },
        {
          th: "Name (Kontaktperson)",
          td: (i) =>
            i.booking.contact && i.booking.contact.lastName != ""
              ? i.booking.contact.lastName + ", " + i.booking.contact.firstName
              : "--",
        },
        {
          th: "Teilnehmende",
          td: (i) => {
            if (i.dates) {
              if (i.booking.participants && i.booking.participants.length > 0) {
                return vue.getAllParticipantNames(i.booking.participants);
              } else {
                return "--";
              }
            } else {
              return i.booking.participantCount;
            }
          },
        },
        {
          th: "Angefragt",
          td: (i) => DateFormatter.formatDateTime(new Date(i.booking.bookingDateTime)),
        },
        {
          th: "Status",
          td: (i) => vue.EventBookingStatusNames[i.booking.state],
        },
        {
          th: "",
          td: (i) => "Daten bearbeiten",
          style: (i) => "text-align:right",
          button: "openDetailsEdit",
        },
      ] as TableViewColumnDefinitions<EventWithBookingJson>[];
    },

    eventColumns: function (): TableViewColumnDefinitions<EventJson>[] {
      let vue = this;

      return [
        {
          th: "Veranstaltung",
          td: (i) => i.title,
        },
        {
          th: "Termine",
          td: (i) =>
            i.dates
              ? i.dates.map((j) => DateFormatter.formatWeekdayDateTimeShort(new Date(j.beginDateTime))).join(" | ")
              : "unbekannt",
        },
        {
          th: "",
          td: (i) => "Veranstaltung ansehen",
          style: (i) => "text-align:right",
          button: "showParticipants",
        },
      ] as TableViewColumnDefinitions<EventJson>[];
    },

    eventBookingIndividualColumns: function (): TableViewColumnDefinitions<EventWithBookingJson>[] {
      let vue = this;

      return [
        {
          th: "Veranstaltung",
          td: (i) => i.title,
        },
        {
          th: "Termine",
          td: (i) =>
            i.booking.bookedDates
              ? i.booking.bookedDates
                  .map((j) => DateFormatter.formatWeekdayDateTimeShort(new Date(j.beginDateTime)))
                  .join(" | ")
              : "unbekannt",
        },
        {
          th: "Name (Kontaktperson)",
          td: (i) =>
            i.booking.contact && i.booking.contact.lastName != ""
              ? i.booking.contact.lastName + ", " + i.booking.contact.firstName
              : "--",
        },
        {
          th: "Status",
          td: (i) => vue.EventBookingStatusNames[i.booking.state],
        },
        {
          th: "",
          td: (i) => "Daten bearbeiten",
          style: (i) => "text-align:right",
          button: "openDetailsEdit",
        },
      ] as TableViewColumnDefinitions<EventWithBookingJson>[];
    },
  },
});
